var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',[(!_vm.isWishope())?_c('vas-details-standard'):_vm._e(),(_vm.isWishope())?_c('vas-details-weshope'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }